module.exports = __webpack_public_path__ + "r-v3/img/exam_white.d02e1622.svg";